import { IResponse, JSONRPCRequest } from '@portals/fetch-api';
import { TResponse } from './types';
import { makeRequestConfig, TGetArticlesParams } from './make-request-config';

export const getArticleOneRequest = (
  params: TGetArticlesParams,
): Promise<IResponse<TResponse>> =>
  new JSONRPCRequest().makeRequest(makeRequestConfig(params));
